export default __webpack_public_path__ + "static/media/2728 knife block B side.e81c5fbb.png";